module.exports = __webpack_public_path__ + "img/type2.2f660404.jpg";